// extracted by mini-css-extract-plugin
module.exports = {"centerEverything":"NewRoom_centerEverything__2y5DE","center":"NewRoom_center__1WQej"};